<div class="statistics-modal">
  <!-- <div class="title">
    <div class="close" (click)="onNoClick()">X</div>
  </div> -->
  <iframe [src]="iframesrc" style="width: 100%; height: 1100px" (load)="paymentpageLoaded()"></iframe>
</div>
